import Disclaimer from '../FormSection/Disclaimer';
import EmailInput from '../Input/EmailInput';
import FirstNameInput from '../Input/FirstNameInput';
import LastNameInput from '../Input/LastNameInput';
import PhoneInput from '../Input/PhoneInput';
import SubmitButton from '../Input/SubmitButton';
import ZipInput from '../Input/ZipInput';
import LeadFormWrapper from './LeadFormWrapper';
import HiddenInput from '../Input/HiddenInput';

export default function HorizontalLeadForm() {
  return (
    <>
      <LeadFormWrapper
        prefix="horizontal"
        className="justify-center mt-6 space-y-2 lg:space-x-2 sm:mx-auto lg:flex md:space-y-0"
      >
        <FirstNameInput
          containerClassName="xl:w-32"
          labelClassName="sr-only"
          errorClassName="ml-2 text-xs"
          placeholder
        />
        <LastNameInput
          containerClassName="xl:w-32"
          labelClassName="sr-only"
          errorClassName="ml-2 text-xs"
          placeholder
        />
        <EmailInput
          containerClassName="xl:w-48"
          labelClassName="sr-only"
          errorClassName="ml-2 text-xs"
          placeholder
        />
        <PhoneInput
          containerClassName="xl:w-32"
          labelClassName="sr-only"
          errorClassName="ml-2 text-xs"
          placeholder
        />
        <ZipInput
          containerClassName="xl:w-28"
          labelClassName="sr-only"
          errorClassName="ml-2 text-xs"
          placeholder
        />

        <div className="mt-1">
          <SubmitButton size="md" className="w-full mt-1" />
        </div>
        <HiddenInput name="address.country" />
        <HiddenInput name="address.street" />
      </LeadFormWrapper>
      <div className="mt-4">
        <Disclaimer />
      </div>
    </>
  );
}
